var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoustonTexansLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: 174.89,
    viewBox: "0 0 191.47542 174.89308",
    width: 191.48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -284.21 581.77)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.76317 .76317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m339.21 440.25c32.436-24.684 7.752-28.379-17.579-31.984 0 0-10.689 2.9487-29.211 12.15-42.008 20.864-28.783 30.695 4.233 36.644-52.841 23.02-96.881-17.06-48.297-56.033l-13.332-9.53c10.951-6.7135 33.641-20.796 30.345-42.362l-11.262-8.0487 34.393-15.585 27.139 12.298c0.19702 11.943 21.543 18.147 30.728 42.441 50.56 11.6 37.682 56.074-7.1562 60.011",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.1 366.51-9.7503 11.09-11.194-1.6691 5.1742 8.524-9.748 11.097 12.949-5.8279 5.1626 8.5263 2.8235-12.122 12.947-5.8186-11.199-1.6737 2.8351-12.126zm15.995 39.474c-63.467 24.512-67.67 44.623-28.055 51.573-49.544 13.462-78.443-22.445-29.422-56.686l-13.153-9.4026c13.967-9.3307 28.769-23.152 23.747-44.901l-6.6277-4.7314 25.456-11.54c23.69 25.947 36.08 51.158 28.055 75.689",
    fill: "#03202f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.32 436.39c21.782-17.053 6.6578-27.948-19.897-30.908 6.7181-28.319-13.881-54.257-35.691-74.342l19.997 9.0594c1.479 11.51 21.768 17.495 31.381 43.035 45.156 10.075 37.786 42.481 4.2098 53.156",
    fill: "#a71930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoustonTexansLogo);
export default __webpack_public_path__ + "static/media/houston-texans-logo.1045048214588a43869d5ce326803668.svg";
export { ForwardRef as ReactComponent };